export default __webpack_public_path__ + "2407c3725a0f3b1899cd6739437d8fa3.svg";